import * as React from 'react'
import {type SchoolAttrs} from '@frontrow/console/src/entities/models/school'
import {mmap} from '@freckle/maybe'

import {dateAccessor} from '@frontrow/console/src/helpers/formatters'
import {
  Field,
  FIELD_GRID_HALF
} from '@frontrow/console/src/components/pages/teachers-page/teacher-information-button-modal/field'

type Props = {
  school: SchoolAttrs
}

export default function SchoolInformation(props: Props): React.ReactElement {
  const {school} = props

  const {
    id,
    name,
    createdAt,
    formattedAddressLines,
    classLinkSchoolId,
    cleverSchoolId,
    renaissanceRpIdentifier
  } = school

  return (
    <div className={FIELD_GRID_HALF}>
      <Field name="Id" value={id} />
      <Field name="Name" value={name} />
      <Field
        name="Address Lines"
        value={mmap(a => a.map((a, i) => <p key={i}>{a}</p>), formattedAddressLines)}
      />
      <Field name="Created At" value={dateAccessor(createdAt)} />
      <Field name="Renaissance RP Identifier" value={renaissanceRpIdentifier} />
      <Field name="ClassLink School Id" value={classLinkSchoolId} />
      <Field name="Clever School Id" value={cleverSchoolId} />
    </div>
  )
}
